import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const BuscaSerieIndicadorService = async (values) => {
    try {
        return await instance.Backend.post("/Indicador/BuscaSerieIndicador", values, customConfig);
    } catch (error) {
        console.log(error);
    }
}
export { BuscaSerieIndicadorService };